module.exports = __webpack_public_path__ + "img/ezJmNnMB.01d75624.svg";